export default {
  system: {
    user: 'ব্যবহারকারী',
    level: 'লেভেল',
    earnPerTap: 'প্রতি ট্যাপে আয়',
    coinsToLevelUp: 'লেভেল আপ করতে কয়েন',
    profitPerHour: 'প্রতি ঘণ্টায় লাভ',
    coming1: 'কিছু আকর্ষণীয়',
    coming2: 'শীঘ্রই আসছে...',
    close: 'বন্ধ করুন',
    friends: 'বন্ধুরা',
    continue: 'চালিয়ে যান',
  },
  settings: {
    chooseNetwork: 'নেটওয়ার্ক বেছে নিন',
    chooseLanguage: 'ভাষা বেছে নিন',
  },
  popup_CheckTask: {
    join: 'যোগ দিন',
    check: 'যাচাই করুন',
    taskIsNotCompleted: 'কাজ সম্পন্ন হয়নি',
  },
  popup_levelUp: {
    levelUp: 'লেভেল আপ!',
    multiTap: 'মাল্টিট্যাপ',
    energyLimit: 'শক্তির সীমা',
  },
  popup_BalanceUp: {
    balanceUp: 'ব্যালেন্স আপডেট!',
    balanceDiffSinceLast: 'আপনার পুরস্কার',
  },
  popup_BalanceTip: {
    tip: 'আপনার লাভ বাড়ান',
    message: 'আপনার নেটওয়ার্কের জন্য আপগ্রেড কিনতে মাইন মেনুতে ট্যাপ করুন',
    description: 'অফলাইনে থাকা অবস্থায়ও 3 ঘণ্টা পর্যন্ত আয় করুন',
  },
  popup_Bored: {
    header: 'ব্যাঙটি বিরক্ত!',
    message: 'ব্যাঙের সাথে খেলুন।',
    description: '3 ঘণ্টা ব্যাঙের সাথে না খেললে লাভ বন্ধ হয়ে যায়',
  },
  popup_Hungry: {
    header: 'ব্যাঙটি ক্ষুধার্ত!',
    message: 'ব্যাঙকে খাওয়ান।',
    description: 'আপনার যত বেশি বন্ধু থাকবে, প্রতিবার খাওয়ানোতে তত বেশি কয়েন আনতে পারে',
  },
  menu: {
    network: 'নেটওয়ার্ক',
    mine: 'মাইন',
    earn: 'আয়',
    food: 'খাবার',
  },
  tap: {
    bored: 'বিরক্ত',
    fun: 'মজা',
  },
  mineMenu: {
    activities: 'কার্যক্রম',
    investments: 'বিনিয়োগ',
    web3: 'ওয়েব3',
    achievements: 'অর্জন',
  },
  leaderboard: {
    from: 'থেকে',
    beTheFirst: 'প্রথম হোন!',
  },
  mine: {
    joinOurTG1: 'আমাদের টেলিগ্রাম চ্যানেলে যোগ দিন,',
    joinOurTG2: 'আনলক করতে!',
    unlock: 'আনলক করুন',
  },
  friends: {
    inviteFriends: 'বন্ধুদের আমন্ত্রণ জানান!',
    receiveBonuses: 'আপনি এবং আপনার বন্ধু বোনাস পাবেন',
    inviteFriend: 'একজন বন্ধুকে আমন্ত্রণ জানান',
    withTelegramPremium: 'টেলিগ্রাম প্রিমিয়াম সহ',
    forYouAndYourFriend: 'আপনার এবং আপনার বন্ধুর জন্য',
    moreBonuses: 'আরও বোনাস',
    listOfYourFriends: 'আপনার বন্ধুদের তালিকা',
    linkCopied: 'আমন্ত্রণ লিংক আপনার ক্লিপবোর্ডে কপি করা হয়েছে!',
    playWithMe:
      'আমার সাথে যোগ দিন এবং এয়ারড্রপের মাধ্যমে টোকেন আয় করতে খেলুন!\n' +
      '💰 আপনার উপহার নিন! নতুনদের জন্য +3000 কয়েন\n' +
      '🚀 টেলিগ্রাম প্রিমিয়াম আছে? +5000 কয়েন পান!\n',
  },
  earn: {
    moreCoins: 'আরও কয়েন আয় করুন!',
    dailyTasks: 'দৈনিক কাজ',
    dailyReward: 'দৈনিক পুরস্কার',
    tasksList: 'কাজের তালিকা',
    joinOurTG: 'আমাদের টেলিগ্রাম চ্যানেলে যোগ দিন',
    followOurX: 'আমাদের X অ্যাকাউন্ট অনুসরণ করুন',
    yourAd: 'আপনার বিজ্ঞাপন এখানে থাকতে পারে',
    connect: 'আমাদের টেলিগ্রাম চ্যানেলের অ্যাডমিনের সাথে যোগাযোগ করুন',
  },
  food: {
    hungry: 'ক্ষুধার্ত',
    full: 'পরিতৃপ্ত',
    frogIsFull: 'ব্যাঙ পরিতৃপ্ত',
    feed: 'খাওয়ান',
    bonus: 'বোনাস',
    satiety: 'তৃপ্তি',
    hours: 'ঘণ্টা',
  },
  toast: {
    buyCard: {
      title: 'অর্জন আনলক হয়েছে!',
      subtitle: 'আপনার ব্যাঙের সাম্রাজ্যকে মহত্বের দিকে নিয়ে যাওয়ার সময় 👑',
    },
    feedFrog: {
      title: 'ব্যাঙটি খুশি!',
      subtitle: 'চমৎকার কাজ! হাসি বজায় রাখতে আপনার পোষা প্রাণীকে খাওয়ান 🍽️',
    },
  },
};
